export function Button(props){
    const type = props.type ?? "button";
    const {className, hover} = props;
    

    return (
        <button {...props} type={type} className={"btn btn-primary " + (className ?? '')} data-toggle={hover && "tooltip"} title={hover}>
            <div className="abs btn-bg"></div>
            {props.children}
        </button>
    )
}


export function IconBut(props){
    let {href, onClick} = props;
    
    if (href){
        return (
            <a href={href} target="_blank" rel="noreferrer" onClick={onClick} className="no-link">
                <div className="abs btn-bg"></div>
                <i className={props.className}> {props.children} </i>
            </a>
        )
    }
 
    return (
        <button type="button" onClick={onClick} className="no-btn" data-toggle={props.hover && "tooltip"} title={props.hover}>
            <div className="abs btn-bg"></div>
            <i className={props.className}> {props.children} </i>
        </button>
    )
}